import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-i-add-blue",
  "use": "icon-i-add-blue-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-i-add-blue\"><path d=\"M103 551.5c-22.091 0-40-17.909-40-40s17.909-40 40-40h818.602c22.091 0 40 17.909 40 40s-17.909 40-40 40H103z\" fill=\"#1890ff\" p-id=\"4895\" /><path d=\"M472.3 103.2c0-22.092 17.91-40 40-40 22.092 0 40 17.908 40 40v818.6c0 22.092-17.908 40-40 40-22.09 0-40-17.908-40-40V103.2z\" fill=\"#1890ff\" p-id=\"4896\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol